export default "__VITE_ASSET__GPeGqDna__"